// generated by genversion
export var version = '4.2.2';
//# sourceMappingURL=version.js.map